import 'idempotent-babel-polyfill';
import alt from '../../alt';
import OrderHistoryActions from './OrderHistoryActions';

class OrderHistoryStore {
	constructor() {
		this.state = {
			OrderList: [],
			Details: {},
			currentComponent: 'history'
		};
		
		this.bindListeners({
			orderListSuccess: OrderHistoryActions.ORDER_LIST_SUCCESS,
			orderDetailSuccess: OrderHistoryActions.ORDER_DETAIL_SUCCESS,
			switchComponent: OrderHistoryActions.SWITCH_COMPONENT,
		});
	}
	
	orderListSuccess(orders) {
		this.setState({
			OrderList: orders
		})
	}
	
	orderDetailSuccess(order) {
		this.setState({
			Details: order,
			currentComponent: 'summary'
		})
	}
	
	switchComponent(name) {
		this.setState({
			currentComponent: name
		})
	}
	
}

export default alt.createStore(OrderHistoryStore, 'OrderHistoryStore');


// WEBPACK FOOTER //
// ./../../Deploy/PWS/ViewModels/Components/MyAccount/OrderHistory/OrderHistoryStore.js